import { Box } from '@mui/material';
import { useState } from 'react';

interface Props {
  children?: React.ReactElement<unknown>;
  form: FormBase<any>
  submit: any
}

export default function ValidForm(props: Props) {
  /** バリデーション実行判定 */
  const [isValidated, setIsValidated] = useState<boolean>(false)

  /** バリデーション処理 */
  const onSubmit = (event: any) => {
    event.preventDefault()
    // ディープコピー
    const val: FormBase<any> = {
      ...props.form,
      value: {
        ...props.form.value
      },
      invalid: {
        ...props.form.invalid
      },
      customValidity: {
        ...props.form.customValidity
      }
    }
    const inputs: Array<HTMLInputElement> = Array.from(event.currentTarget)
    // エラーメッセージを設定
    inputs.forEach((el) => {
      const key = el.id as keyof typeof val
      // カスタムバリデーションがある場合はそちらも確認
      if (props.form.customValidity[key]) {
        const customValidity: Function = props.form.customValidity[key]
        customValidity(el)
      }
      val.invalid[key] = el.validationMessage
    })
    // 入力エラー判定
    const inValid = inputs.find(el => !el.validity.valid)
    if (inValid) {
      // エラーの最初の要素をフォーカス
      inValid.focus()
    }
    if (inValid) {
      setIsValidated(true)
      props.submit(val, false)
    } else {
      setIsValidated(false)
      props.submit(val, true)
    }
  }
  return (
    <Box
      component={'form'}
      onSubmit={onSubmit}
      noValidate
    >
      {props.children}
    </Box >
  )
}